























import Vue from "vue";

export default Vue.extend({
  name: "OverlayWindow",
  props: {
    title: String,
    size: String,
  },
  data() {
    return {};
  },
  methods: {
    closeOverlayMenu: function () {
      this.$emit("closeOverlayWindow");
    },
  },
});
